import { Dashboard } from "./components/Dashboard";

export function Carrier() {
  return <Dashboard />;
}
